import { render, staticRenderFns } from "./RateBreweryForm.vue?vue&type=template&id=c57d6022&"
import script from "./RateBreweryForm.vue?vue&type=script&lang=ts&"
export * from "./RateBreweryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RateBreweryForm.vue"
export default component.exports